import { gql } from '@apollo/client';
export default gql`
  query getOperationHritems($opId: String) {
    getOperationHritems(opId: $opId) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo

        opId
        opType
        opDocNo

        isWorking
        isAbsent
        isShift1
        isShift2
        bonosvalue
        bonosqty
        bonos
        overtimevalue
        overtimeqty
        overtime
        deductionvalue
        deductionqty
        deduction
        desc

        contractId
        contractName
        contractNameAr
        departmentId
        departmentName
        departmentNameAr
        employeeId
        employeeName
        employeeNameAr

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
